jQuery(document).on('ready', function(){
	MODAL.onReady();
});



var MODAL = {
	onReady : function(){
		var $modal = jQuery('#modal');

		if ( $modal.length > 0 && sessionStorage.getItem("modal") == undefined  ) {
			MODAL.show( $modal );
		}

		jQuery(document).on('click', '#modal .close', function(){
			MODAL.hide( $modal );
			sessionStorage.setItem("modal", false);
		});

	},

	show : function( $modal ){
		$modal.delay( 300 ).fadeIn();
	},

	hide : function( $modal ){
		$modal.fadeOut('fast');
	}
}